import { render, staticRenderFns } from "./BusinessStartupPageCustomerOrderEdit.vue?vue&type=template&id=18e337e9&"
import script from "./BusinessStartupPageCustomerOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./BusinessStartupPageCustomerOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e337e9')) {
      api.createRecord('18e337e9', component.options)
    } else {
      api.reload('18e337e9', component.options)
    }
    module.hot.accept("./BusinessStartupPageCustomerOrderEdit.vue?vue&type=template&id=18e337e9&", function () {
      api.rerender('18e337e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/BusinessStartupPageCustomerOrderEdit.vue"
export default component.exports